//@ts-nocheck
import ComponentRegistry from '../../../../utils/react-registry/src/lib/ComponentRegistry'

export const getRegistry = (registry) => {
    const instance = ComponentRegistry.getInstance().getRegistry(registry)['registry']['map'];
    return instance
}